var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.23 0 0 0.23 240.03 240.08)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.17 -417)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(3,108,112)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 556
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 486.5 92.67)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(26,155,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 509.667
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 92.67 579.17)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(55,198,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 393.833
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -208.54 23.17)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-787.63, -996.17)",
    d: "M 1112 501.79 v 988.753 c -0.23 34.357 -21.05 65.222 -52.82 78.303 c -10.116 4.279 -20.987 6.484 -31.97 6.487 H 695.463 c -0.463 -7.877 -0.463 -15.29 -0.463 -23.167 c -0.154 -7.734 0.155 -15.47 0.927 -23.167 c 8.48 -148.106 99.721 -278.782 235.837 -337.77 v -86.18 c -302.932 -48.005 -509.592 -332.495 -461.587 -635.427 c 0.333 -2.098 0.677 -4.195 1.034 -6.289 c 2.306 -15.626 5.556 -31.099 9.73 -46.333 h 546.27 C 1073.964 417.178 1111.822 455.036 1112 501.79 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -231.74 69.5)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-764.43, -1042.5)",
    d: "M 980.877 463.333 H 471.21 c -51.486 302.386 151.908 589.256 454.293 640.742 c 9.156 1.559 18.35 2.888 27.573 3.986 c -143.633 68.11 -248.3 261.552 -257.196 420.938 c -0.771 7.697 -1.081 15.433 -0.927 23.167 c 0 7.877 0 15.29 0.463 23.167 c 0.836 15.574 2.85 31.063 6.023 46.333 h 279.39 c 34.357 -0.23 65.222 -21.05 78.303 -52.82 c 4.279 -10.115 6.485 -20.987 6.487 -31.97 V 548.123 C 1065.443 501.387 1027.613 463.537 980.877 463.333 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -231.71 23.17)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-764.46, -996.17)",
    d: "M 980.877 463.333 H 471.21 c -51.475 302.414 151.95 589.297 454.364 640.773 c 6.186 1.053 12.389 2.001 18.607 2.844 c -139 73.021 -239.543 266 -248.254 422.05 h 284.95 c 46.681 -0.353 84.437 -38.109 84.79 -84.79 V 548.123 C 1065.489 501.369 1027.631 463.511 980.877 463.333 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -254.87 23.17)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-741.3, -996.17)",
    d: "M 934.543 463.333 H 471.21 c -48.606 285.482 130.279 560.404 410.977 631.616 C 775.901 1216.384 710.711 1368.301 695.927 1529 h 238.617 c 46.754 -0.178 84.612 -38.036 84.79 -84.79 V 548.123 C 1019.308 501.306 981.361 463.359 934.543 463.333 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -486.5 0)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_SVGID_1__5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 1948)",
    x1: 177.0788,
    y1: 1551.0284,
    x2: 842.2545,
    y2: 398.9716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(5,143,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "rgb(3,132,137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(2,109,113)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_SVGID_1__5)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-509.67, -973)",
    d: "M 84.929 463.333 h 849.475 c 46.905 0 84.929 38.024 84.929 84.929 v 849.475 c 0 46.905 -38.024 84.929 -84.929 84.929 H 84.929 c -46.905 0 -84.929 -38.024 -84.929 -84.929 V 548.262 C 0 501.357 38.024 463.333 84.929 463.333 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -479.14 0.06)",
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-517.02, -973.06)",
    d: "M 379.331 962.621 c -19.903 -13.202 -36.528 -30.777 -48.604 -51.384 c -11.701 -21.542 -17.533 -45.781 -16.912 -70.288 c -1.042 -33.181 10.155 -65.586 31.46 -91.045 c 22.388 -25.49 51.326 -44.366 83.678 -54.581 c 36.871 -12.136 75.49 -18.116 114.304 -17.699 c 51.043 -1.865 102.015 5.272 150.583 21.082 v 106.567 c -21.103 -12.784 -44.088 -22.166 -68.11 -27.8 c -26.065 -6.392 -52.81 -9.597 -79.647 -9.545 c -28.3 -1.039 -56.419 4.913 -81.871 17.329 c -19.65 8.475 -32.392 27.807 -32.433 49.206 c -0.08 12.981 4.907 25.481 13.9 34.843 c 10.622 11.037 23.187 20.021 37.067 26.503 c 15.444 7.691 38.611 17.916 69.5 30.673 c 3.401 1.075 6.716 2.407 9.915 3.985 c 30.401 11.881 59.729 26.344 87.663 43.229 c 21.154 13.043 38.908 30.924 51.801 52.171 c 13.218 24.085 19.625 51.315 18.533 78.767 c 1.509 34.066 -8.913 67.591 -29.468 94.798 c -20.488 25.012 -47.88 43.446 -78.767 53.005 c -36.329 11.387 -74.245 16.892 -112.312 16.309 c -34.154 0.155 -68.258 -2.635 -101.933 -8.34 c -28.434 -4.653 -56.182 -12.807 -82.612 -24.279 v -112.358 c 25.264 18.043 53.489 31.529 83.4 39.847 c 29.81 9.289 60.798 14.251 92.018 14.734 c 28.895 1.83 57.739 -4.291 83.4 -17.699 c 17.976 -10.144 28.909 -29.358 28.449 -49.994 c 0.12 -14.359 -5.56 -28.158 -15.753 -38.271 c -12.676 -12.444 -27.352 -22.671 -43.414 -30.256 c -18.533 -9.267 -45.824 -21.483 -81.871 -36.65 C 432.618 993.951 405.161 979.594 379.331 962.621 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/Sharepoint.b5bdacfcae82345188862b56b1baf8a3.svg";
export { ForwardRef as ReactComponent };